import { AutenticacionService } from './autenticacion.service';
import { ErrorsService } from './tools/errors.service';
import { ValidatorService } from './tools/validator.service';
import { ConstantsService } from './constants.service';
import { Http, ResponseContentType, URLSearchParams } from '@angular/http';
import { Injectable } from '@angular/core';
declare var $;

@Injectable()
export class CuentasService {
  public url:string;

  constructor(private http: Http, private constant: ConstantsService, private validatorService: ValidatorService, private errorService:ErrorsService, private authService: AutenticacionService){
    this.url = constant.apiURL;
  }

  public getDefaultSchedule(){
    return {
      'idCuentas': '',
      'nombreCuenta': '',
      'numeroCuenta': '',
      'nombreBanco': '',
      'notas': '',
      'saldoActual': '',
      'tipoCuenta': '',
      'activa': 1,
      'obras': '',
      'balcasa':0,
      'kr':0,
    };
  }

  public getCuentaTipo(id, security){
    return this.getCuentasTipos(security).find(item => {
      return item.id == id;
    });
  }

  public getCuentasTipos(security = false){
    const cuentasTipos = [{'id':1, 'nombre':'Bancaria'}];
    if (security) {
      cuentasTipos.push({'id':2, 'nombre':'Sobre-Efectivo'});
    }
    return cuentasTipos;
  }

  // objeto cuenta simple
  public getCuentas(page, idObras){
    // solo paginacion
    if(page && !idObras)
      return this.http.get(this.url + "/cuentas?paginate=true&page=" + page, this.authService.getAuthHeaders());

      // solo filtrar
    if(!page && idObras)
      return this.http.get(this.url + "/cuentas?paginate=true&idObras=" + idObras, this.authService.getAuthHeaders());

      //paginacion y filtrar
    if(page && idObras)
      return this.http.get(this.url + "/cuentas?paginate=true&page=" + page + "&idObras=" + idObras, this.authService.getAuthHeaders());

      // solo cuentas
    return this.http.get(this.url + "/cuentas?paginate=true", this.authService.getAuthHeaders());
  }

  public getCuentastoSelect(preffix = '') {
    return this.http.get(this.url + preffix + '/cuentas?select=true', this.authService.getAuthHeaders());
  }

  public getCuentasByObraToSelect(idObras, preffix = '') {
    return this.http.get(this.url + preffix + '/cuentas?select=true&idObras=' + idObras, this.authService.getAuthHeaders());
  }

  public getCuentasByObraToSelectSobre(idObras, preffix = '') {
    return this.http.get(this.url + preffix + '/cuentas?select=true&validarOrigen=false&idObras=' + idObras, this.authService.getAuthHeaders());
  }

  public getCuentasSobreTodas() {
    return this.http.get(this.url + '/cuentas/sobre-todas?validarOrigen=false', this.authService.getAuthHeaders());
  }

  // buscar objeto simple
  public searchCuentas(search, page, idObras){
    // buscar con paginacion
    if(page && !idObras)
      return this.http.get(this.url + "/cuentas?paginate=true&search=" + search + "&page=" + page, this.authService.getAuthHeaders());

    // buscar con filtrar
    if(!page && idObras)
      return this.http.get(this.url + "/cuentas?paginate=true&search=" + search + "&idObras=" + idObras, this.authService.getAuthHeaders());

    // buscar con paginacion y filtrar
    if(page && idObras)
      return this.http.get(this.url + "/cuentas?paginate=true&search=" + search + "&page=" + page + "&idObras=" + idObras, this.authService.getAuthHeaders());

    // solo buscar
    return this.http.get(this.url + "/cuentas?paginate=true&search=" + search, this.authService.getAuthHeaders());
  }

  public createCuenta(data){
    return this.http.post(this.url + '/cuentas', data, this.authService.getAuthHeaders());
  }

  public updateCuenta(data, id){
    return this.http.put(this.url + '/cuentas?id=' + id, data, this.authService.getAuthHeaders());
  }

  public deleteCuenta(id){
    return this.http.delete(this.url + '/cuentas/'+id, this.authService.getAuthHeaders());
  }

  public activeSecurityModule(password) {
    const data = {password:password}
    return this.http.post(this.url + '/cuentas/key', data, this.authService.getAuthHeaders());
  }

  public writePermission() {
    return this.authService.hasPermission(3, true);
  }

  public canExport() {
    return this.authService.canExport();
  }

  public canSecurity() {
    return this.authService.canSecurity();
  }

  public export(search, idObras) {
    var url = this.url + '/cuentas/exportar?search='+search;
    if(idObras) {
      url = url + '&idObras='+idObras;
    }
    const options = this.authService.getAuthHeaders();
    options.responseType = ResponseContentType.Blob;
    return this.http.get(url, options)
    .map((response) => {
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(response.blob());
      const contentDispositionHeader = response.headers.get('content-disposition');
      const result = contentDispositionHeader.split(';')[1].trim().split('=')[1];
      link.download = result.replace(/"/g, '');
      document.body.appendChild(link); 
      link.click();
      setTimeout(() => {
        link.remove();
      }, 200);
    });
  }

  public validateCuenta(data){
    console.log("validating... ", data);
    
    let error = [];
    

    // validacion de NOMBRE DE CUENTA
    if(!this.validatorService.required(data["nombreCuenta"])){
      error["nombreCuenta"] = this.errorService.required;
    }
    else if(!this.validatorService.max(data["nombreCuenta"], 50)){
      error["nombreCuenta"] = this.errorService.max(50);
    }

    // validacion de NOMBRE BANCO
    if(!this.validatorService.required(data["nombreBanco"])){
      error["nombreBanco"] = this.errorService.required;
    }
    else if(!this.validatorService.max(data["nombreBanco"], 50)){
      error["nombreBanco"] = this.errorService.max(50);
    }

   
    
    // validacion de TIPO CUENTA
    if(!this.validatorService.required(data["tipoCuenta"])){
      error["tipoCuenta"] = this.errorService.required;
    }

    // validacion de OBRA
    if(!this.validatorService.required(data["obras"])){
      error["obras"] = this.errorService.required;
    }

    // validacion de TELEFONO2
    if(data["notas"] && !this.validatorService.max(data["notas"], 200)){
      error["notas"] = this.errorService.max(200);
    }

    return error;
  }

  public getCuentasMixtas(filters : any) {
    let myParams = new URLSearchParams();

    if(filters.idObras){
        myParams.append('idObras', filters.idObras);
    }

    let myoptions = this.authService.getAuthHeaders();
    myoptions.params = myParams;
    
    let serviceUrl = this.url + '/cuentas-mixtas';
    
    return this.http.get(serviceUrl , myoptions);
  }  

}



// WEBPACK FOOTER //
// ./src/app/services/cuentas.service.ts